import { AiToolOffice } from '../ai-details/ai-tool-office';
import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddQuestionTempCategoryComponent } from '../addQuesTempCategory/addQuesTempCategory.component';
import { AddQualifyingTempCategoryComponent } from '../addQualifyingTempCategory/addQualifyingTempCategory.component';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-saveUpdateQualifyingTemplate',
  templateUrl: './saveUpdateQualifyingTemplate.component.html',
  styleUrls: ['./saveUpdateQualifyingTemplate.component.scss'] 
})

export class SaveUpdateQualifyingTemplate implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any; 
  spinner:boolean=false;

   addTemplateForm: FormGroup;
  filteredTaskCategoryList: any = ([] = []);
  ShowNoRecordFoundTaskTemplates: Boolean = false;
 

  taslTemplateID: number = 0;
  tempCategoryList: any = ([] = []);
  showSaveTemplate: Boolean = false;
  QuestionTemplateID: number = 0;

  QualifyingCategoryList: any = ([] = []);
  filteredQualifyingCategoryList: any = ([] = []);

  updateQuestionTemplateButton: boolean = false;
  showNew: boolean = false;
  showExisting: boolean = false;
  ShowNoRecordFoundQuestionTemplate: boolean = false;
  TemplatesListForQuestion: any = ([] = []);
  updateQuestionTemplateTasksButton: boolean = false;
  QuestioncategoryType: number = 0;
 
  QualifyingTemplatesList: any = ([] = []);
  QualifyingTemplatesListFilter: any = ([] = []);

  selectedcategoryIDForQuestion: number = 0;
  templateID: number = 0;
  QuestionTemplateIDImportTask: number = 0;
  selectedCategory: number = 0;
  deletedQuery: any = ([] = []);
  selectedcategoryIDForUpdate: number = 0;
 
  searchTemplateQuestion: string = '';
  categoryType: number = 0;

  timeout = null;
  isOrganizationAdmin: boolean = false;
  isOfficeAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  rolesAsssign:any=[]=[];
  ThresholdList:any=[]=[];
  thresholdValue:number=0;

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<SaveUpdateQualifyingTemplate>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService,private loaderService: LoaderService, ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID = AiToolOffice.resolve(oe.officeID);   // [per-office] the office the open AI tool works for
      });
    }    
  }  
  
  ngOnInit(): void {     
    this.categoryType = 0;
    this.showNew = true;
    this.showExisting = false;
    this.thresholdValue=this.data.thresholdValue;
    let group = {};
    this.addTemplateForm = new FormGroup(group);
    this.createSaveAsTaskTemplate();
    this.ThresholdList= this.data.thresholdRulesList;
    //this.getThresholdRules();
    this.rolesAsssign = JSON.parse(sessionStorage.getItem('roles'));
    if (this.rolesAsssign.length > 0) {
      this.isOfficeAdmin = this.rolesAsssign.find((m:any) => m.roleName == 'Office Admin') !=undefined;
      this.isOrganizationAdmin = this.rolesAsssign.find((m:any) => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find((m:any) => m.roleName == 'Super Admin') != undefined;
    }
    this.getActiveGetReferralTemplateCategoriesAfterAdd('');
  }
         
   createSaveAsTaskTemplate(): void {
    this.addTemplateForm = this.formBuilder.group({
      taskTemplateName: ['', [Validators.required]],
      folderID: ['', [Validators.required]],
    });
  }

  getThresholdRules() {
    var ReqModel = {
      coreID: this.data.transactionID,
      documentID:this.data.documentId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.coreService.getReferralQuestionAnswers(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ThresholdList=this.responseHolder.data.questions;              
        } else {
          this.ThresholdList=[];
         this.loaderService.hide();
        }
      } else {
        this.ThresholdList=[];
        this.loaderService.hide();
      }
    });
  }

  getActiveGetReferralTemplateCategoriesAfterAdd(categoryName: string) {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      isCategoriesOnly: true,
      isAll: false,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0,
    };
    this.coreService.getReferralTemplateCategories(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QualifyingCategoryList = response.data;
          this.filteredQualifyingCategoryList = this.QualifyingCategoryList.filter((m:any) => m.type == this.categoryType);
          if (categoryName != '') {
            var check = [];
            check = this.QualifyingCategoryList.filter((x:any) => x.templateCategoryName.toLowerCase() == categoryName.toLowerCase());
            if (check.length > 0) {
              this.addTemplateForm.controls['folderID'].setValue(check[0].templateCategoryID);
            }
          }
        } else {
          this.QualifyingCategoryList = [];
          this.filteredQualifyingCategoryList = [];
        }
      } else {
        this.QualifyingCategoryList = [];
        this.filteredQualifyingCategoryList = [];
      }
    });
  }

  
  searchTemplateForQuestion(val:any) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.updateQuestionTemplateButton = false;
          this.QualifyingTemplatesList = this.QualifyingTemplatesListFilter.filter(
            (i:any) =>
              i.tempalteName.toLowerCase().indexOf(val.toLocaleLowerCase()) !==
              -1
          );
          if (this.QualifyingTemplatesList.length > 0) {
            this.ShowNoRecordFoundQuestionTemplate = false;
          } else {
            this.ShowNoRecordFoundQuestionTemplate = true;
          }
        }, 500);
      } else {
      }
    } else {
      this.updateQuestionTemplateButton = false;
      this.QualifyingTemplatesList = this.QualifyingTemplatesListFilter;
      //this.getTaskTemplatesForSingleTask();
    }
  }

   getSelectQuestionTemplate(e: any) {
    this.searchTemplateQuestion = '';
    this.selectedcategoryIDForQuestion = e.value;
    this.updateQuestionTemplateButton = false;
    this.getReferralTemplates();
  }

   OnCategoryChange(categoryTypeValue: number) { 
    this.selectedCategory = 0;
    this.selectedcategoryIDForQuestion=0;
    this.QualifyingCategoryList = [];
    this.filteredQualifyingCategoryList = [];
    this.QualifyingTemplatesList=[];
    this.categoryType = categoryTypeValue;
    this.getActiveGetReferralTemplateCategoriesAfterAdd('');
    this.getReferralTemplates();
  }

   getTabDetailsQuestionTemplate(event:any) {
    this.searchTemplateQuestion = '';
    this.selectedcategoryIDForQuestion = 0;
    this.selectedcategoryIDForUpdate = 0;
    this.templateID = 0;
    this.showNew = true;
    this.showExisting = false;
    this.updateQuestionTemplateButton = false;
    //this.filteredQuestionCategoryList=[];
    this.createSaveAsTaskTemplate();
    this.QualifyingTemplatesList=[];
    if (event.tab.textLabel == 'New' || event.index == 0) {
      this.showNew = true;
      this.showExisting = false;
    }
    if (event.tab.textLabel == 'Update Existing' || event.index == 1) {
      this.selectedCategory = 0;
      this.showNew = false;
      this.showExisting = true;
      this.getReferralTemplates();
    }
  }

  getReferralTemplates() {
    var ReqModel = {
      templateType: this.categoryType, // For My Template
      categoryID: this.selectedcategoryIDForQuestion,
      isAll: true,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.coreService.getReferralTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if(this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QualifyingTemplatesList = response.data;
          this.QualifyingTemplatesListFilter = response.data;
          if (this.QualifyingTemplatesList.length > 0) {
            this.ShowNoRecordFoundQuestionTemplate = false;
          } else {
            this.ShowNoRecordFoundQuestionTemplate = true;
          }
        } else {
          this.QualifyingTemplatesList = [];
          this.QualifyingTemplatesListFilter = [];
        }
      } else {
        this.QualifyingTemplatesList = [];
        this.QualifyingTemplatesListFilter = [];
      }
    });
  }

   openDialogAddQuestionTemplate() {
      const dialogRef = this.dialog.open(AddQualifyingTempCategoryComponent, {
        data: {
          categoryType: Number(this.categoryType),
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result != null && result != undefined) {
          this.getActiveGetReferralTemplateCategoriesAfterAdd(result);
        }
      });
    }

   SelectTemplateForQuestionTemplate(temp: any) {
    this.templateID = temp.templateID;
    this.selectedcategoryIDForUpdate = temp.categoryID;
    this.updateQuestionTemplateButton = true;
  }

   closeDialog(){
    this.addTemplateForm.reset();
    this.dialogRef.close();
  }

  AddQualifyingTemplate(data:any) {
    if (this.ThresholdList.length == 0) {
      this.toastr.warning('Please add Threshold & rules.', '', {
        timeOut: 3000,
      });
      return;
    }
    var checkquestion = [];
    checkquestion = this.ThresholdList.filter((x:any) => x.questionTitle != '' || x.quetionID > 0);
    if (checkquestion.length == 0) {
      this.toastr.warning('Please add Threshold & rules.', '', {
        timeOut: 3000,
      });
      return;
    }
    var tempQuery = [];
    if (this.ThresholdList.length > 0) {
      for (let i = 0; i < this.ThresholdList.length; i++) {
        if(this.ThresholdList[i].mandatoryRule==false){
          this.ThresholdList[i].isMandatoryPass=false;
        }
        var obj = {
          questionID: this.ThresholdList[i].quetionID,
          questionTitle: this.ThresholdList[i].questionTitle,
          userPrompt: "",
          propmtHelper: "",
          sysPropmt: "",
          isMandatoryPass: this.ThresholdList[i].isMandatoryPass,
          mandatoryRule: this.ThresholdList[i].mandatoryRule,
          weight: this.ThresholdList[i].weight,
          position: this.ThresholdList[i].position,
          memoryCardID: this.ThresholdList[i].memoryCard?.memoryCardID ?? 0, 
          isFollowUpFlag: this.ThresholdList[i].isFollowUpFlag || false   
        };
        tempQuery.push(obj);
      }
    }
    this.loaderService.show();
    var ReqModel = {
      templateName: data.taskTemplateName,
      templateType: this.categoryType, // For My Template
      categoryID: data.folderID,
      thresholdValue:Number(this.thresholdValue),
      templateQueries: tempQuery,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.spinner = true;
    this.addTemplateForm.markAsPristine();
    this.coreService.addReferralTemplate(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.success('Template added successfully.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close("RecordAdded");
        } else {
          this.toastr.error('Template add failed.', '', {
            timeOut: 3000,
          });
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Template add failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }
 
  updateQualifyingTemplateData() {
   if (this.ThresholdList.length == 0) {
      this.toastr.warning('Please add Threshold & rules.', '', {
        timeOut: 3000,
      });
      return;
    }
    var checkquestion = [];
    checkquestion = this.ThresholdList.filter((x:any) => x.questionTitle != '' || x.quetionID > 0);
    if (checkquestion.length == 0) {
      this.toastr.warning('Please add Threshold & rules.', '', {
        timeOut: 3000,
      });
      return;
    }

    var tempQuery = [];
    if (this.ThresholdList.length > 0) {
      for (let i = 0; i < this.ThresholdList.length; i++) {
         if(this.ThresholdList[i].mandatoryRule==false){
          this.ThresholdList[i].isMandatoryPass=false;
        }
        var obj = {
          questionID: this.ThresholdList[i].quetionID,
          questionTitle: this.ThresholdList[i].questionTitle,
          userPrompt: "",
          propmtHelper: "",
          sysPropmt: "",
          isMandatoryPass: this.ThresholdList[i].isMandatoryPass,
          mandatoryRule: this.ThresholdList[i].mandatoryRule,
          weight: this.ThresholdList[i].weight,
          position: this.ThresholdList[i].position,   
          memoryCardID: this.ThresholdList[i].memoryCard?.memoryCardID ?? 0,
          isFollowUpFlag: this.ThresholdList[i].isFollowUpFlag || false     
        };
        tempQuery.push(obj);
      }
    }
    
    var ReqModel = {
      templateID: this.templateID,
      templateType: this.categoryType, // For My Template
      categoryID: this.selectedcategoryIDForUpdate,
      queries: tempQuery,
      deleteQueries: [],
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
    };
    this.spinner = true;
    this.loaderService.show();
    this.coreService.updateReferralTemplate(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.deletedQuery = [];
          this.spinner = false;
          this.loaderService.hide();
          this.toastr.success('Template update successfully.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close("RecordUpdated");
        } else {
          this.toastr.error('Template update failed.', '', {
            timeOut: 3000,
          });
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Template update failed.', '', {
          timeOut: 3000,
        });
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }
    
}
